import { render } from "./Liabilities.vue?vue&type=template&id=ff167f42&scoped=true"
import script from "./Liabilities.vue?vue&type=script&lang=js"
export * from "./Liabilities.vue?vue&type=script&lang=js"

import "./Liabilities.vue?vue&type=style&index=0&id=ff167f42&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff167f42"]])

export default __exports__